import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "18",
  height: "16",
  viewBox: "0 0 18 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M17 1.77614V6.44404M17 6.44404H12.6364M17 6.44404L13.6255 3.05203C12.8438 2.21548 11.8768 1.60437 10.8147 1.27572C9.75255 0.947078 8.6299 0.91161 7.55148 1.17263C6.47307 1.43365 5.47404 1.98264 4.64761 2.76839C3.82119 3.55414 3.1943 4.55104 2.82545 5.66605M1 14.2239V9.55596M1 9.55596H5.36364M1 9.55596L4.37455 12.948C5.15618 13.7845 6.12318 14.3956 7.18532 14.7243C8.24745 15.0529 9.3701 15.0884 10.4485 14.8274C11.5269 14.5664 12.526 14.0174 13.3524 13.2316C14.1788 12.4459 14.8057 11.449 15.1745 10.3339",
  stroke: "white",
  "stroke-width": "1.2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }